<div mat-dialog-header>
  <h1 *ngIf="isModifica" mat-dialog-title>Selezionare il punto segnalazione su mappa <mat-icon
      style="vertical-align: middle;"
      matTooltipPosition="below" 
      matTooltipClass="map-tooltip"
      matTooltip="Cliccare e trascinare per spostare la mappa, cliccare sul punto preciso per geolocalizzarlo, infine selezionare il pulsante 'Cattura coordinate'">
      info</mat-icon>
  </h1>
  <h1 *ngIf="!isModifica" mat-dialog-title>Punto segnalazione su mappa <mat-icon 
      style="vertical-align: middle;"
      matTooltipPosition="right" 
      matTooltipClass="map-tooltip"
      matTooltip="Cliccare e trascinare per spostare la mappa, cliccare sul punto preciso per geolocalizzarlo">
      info</mat-icon>
  </h1>
</div>
<div mat-dialog-content>
  <div id="map" leaflet (leafletMapReady)="onMapReady($event)" [leafletOptions]="mapOptions">
  </div>
</div>
<div class="titolo flex-display">
  <div class="flex-display">
    <!--<button mat-stroked-button class="pers">
    </button>-->
    <div class="denom">
    </div>
  </div>

  <div class="flex-row">
    <button mat-stroked-button color='basic' class="pers2 mleft mtop" (click)="onButtonClick()">
      ANNULLA
    </button>
    <button *ngIf="isModifica" mat-flat-button color='accent' class="pers3 mleft mtop" (click)="onButtonClick()">
      CATTURA COORDINATE
    </button>
  </div>
</div>